<toggle-slide (click)="triggerDemoToggle()" #demoToggleSlide [activeIndex]="toggleActive ? '1' : '0'"></toggle-slide>
  <span>Only show results from {{ localSearchProduct }}</span>
<div class="search-div">
  <search-tooltip toolinfo="When browsing within a product family, use the toggle to focus your search."></search-tooltip>
</div>
